import i18n from "~/i18n";

export const AuthPluginDescConstant = [
	{
		idx: 1,
		desc: i18n.t("pages.myPage.admin.AuthPage.AuthPluginDescConstant.idx1"),
	},
	{
		idx: 2,
		desc: i18n.t("pages.myPage.admin.AuthPage.AuthPluginDescConstant.idx2"),
	},
	{
		idx: 3,
		desc: i18n.t("pages.myPage.admin.AuthPage.AuthPluginDescConstant.idx3"),
	},
	{
		idx: 4,
		desc: i18n.t("pages.myPage.admin.AuthPage.AuthPluginDescConstant.idx4"),
	},
	{
		idx: 5,
		desc: i18n.t("pages.myPage.admin.AuthPage.AuthPluginDescConstant.idx5"),
	},
	{
		idx: 6,
		desc: i18n.t("pages.myPage.admin.AuthPage.AuthPluginDescConstant.idx6"),
	},
	{
		idx: 7,
		desc: i18n.t("pages.myPage.admin.AuthPage.AuthPluginDescConstant.idx7"),
	},
	{
		idx: 8,
		desc: i18n.t("pages.myPage.admin.AuthPage.AuthPluginDescConstant.idx8"),
	},
	{
		idx: 9,
		desc: i18n.t("pages.myPage.admin.AuthPage.AuthPluginDescConstant.idx9"),
	},
	{
		idx: 10,
		desc: i18n.t("pages.myPage.admin.AuthPage.AuthPluginDescConstant.idx10"),
	},
	{
		idx: 11,
		desc: i18n.t("pages.myPage.admin.AuthPage.AuthPluginDescConstant.idx11"),
	},
	{
		idx: 12,
		desc: i18n.t("pages.myPage.admin.AuthPage.AuthPluginDescConstant.idx12"),
	},
	{
		idx: 13,
		desc: i18n.t("pages.myPage.admin.AuthPage.AuthPluginDescConstant.idx13"),
	},
	{
		idx: 14,
		desc: i18n.t("pages.myPage.admin.AuthPage.AuthPluginDescConstant.idx14"),
	},
	{
		idx: 15,
		desc: i18n.t("pages.myPage.admin.AuthPage.AuthPluginDescConstant.idx15"),
	},
	{
		idx: 16,
		desc: i18n.t("pages.myPage.admin.AuthPage.AuthPluginDescConstant.idx16"),
	},
	{
		idx: 17,
		desc: i18n.t("pages.myPage.admin.AuthPage.AuthPluginDescConstant.idx17"),
	},
	{
		idx: 18,
		desc: '스타트업을 평가할 심사항목을 등록하여 관리할 수 있습니다.',
	},
	{
		idx: 19,
		desc: '내 정보를 관리할 수 있습니다.',
	},
	{
		idx: 20,
		desc: '비밀번호를 변경할 수 있습니다.',
	},
	{
		idx: 21,
		desc: '라이센스 선택 및 관리를 관리할 수 있습니다.',
	},
	{
		idx: 22,
		desc: '결제 이력 및 결제수단을 관리할 수 있습니다.',
	},
];
